import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ChatComponent, SplitPaneComponent } from '@components';
import { SplitPaneVerticalComponent, HistoryComponent } from '@components';

interface GuardrailsDraft {
  policyTier: string;
  enforcementMode: string;
  releaseBlockNotes: string;
}

@Component({
  selector: 'app-guardrails',
  templateUrl: './guardrails.page.html',
  styleUrls: ['./guardrails.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent
],
})
export class GuardrailsPage {
  public guardrailSuggestions: any[] = [
    { icon: 'bi bi-shield', prompt: 'List current violations' },
    { icon: 'bi bi-tools', prompt: 'Propose auto-fixes for top issues' },
    { icon: 'bi bi-toggles', prompt: 'Show rule configuration' },
  ];

  public guardrailContext: any = {
    page: 'guardrails',
    purpose: 'Manage rules, violations and auto-fixes',
    rules: [],
    violations: [],
    autofixes: [],
    outputs: ['Violation summary', 'Auto-fix proposals', 'Rule config overview']
  };

  public applyingGuardrails = false;
  public guardrailsError = '';
  public guardrailsSuccess = '';
  public hasAppliedGuardrails = false;
  public guardrailsDraft: GuardrailsDraft = {
    policyTier: '',
    enforcementMode: '',
    releaseBlockNotes: '',
  };

  public readonly policyTierOptions = ['Baseline', 'Hardened', 'Regulated'];
  public readonly enforcementModeOptions = ['Advisory only', 'Warn and require approval', 'Hard block'];

  constructor() {}

  public async applyGuardrails(): Promise<void> {
    this.guardrailsError = '';
    this.guardrailsSuccess = '';
    this.hasAppliedGuardrails = false;

    if (!this.guardrailsDraft.policyTier.trim()) {
      this.guardrailsError = 'Select a policy tier before applying guard rails.';
      return;
    }
    if (!this.guardrailsDraft.enforcementMode.trim()) {
      this.guardrailsError = 'Select an enforcement mode before applying guard rails.';
      return;
    }

    this.applyingGuardrails = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasAppliedGuardrails = true;
      this.guardrailsSuccess = 'Guard rails applied to the current release workflow.';
    } finally {
      this.applyingGuardrails = false;
    }
  }
} 